export default __webpack_public_path__ + "static/media/htbabyImg6.87b2af59.png";